import { href, Navigate } from 'react-router';

import { useUser } from '~entities/session';
import { UserRole } from '~entities/user';
import { type PharmacyRoute, usePharmacyId } from '~shared/routes';

type RoleRedirectProps = {
  roleRedirects: Partial<Record<UserRole, PharmacyRoute>>;
  defaultRedirect: PharmacyRoute;
};

export const RoleBasedIndexRedirect = ({
  roleRedirects,
  defaultRedirect,
}: RoleRedirectProps) => {
  const pharmacyId = usePharmacyId();
  const user = useUser(pharmacyId);

  const destination = user?.role
    ? roleRedirects[user.role] || defaultRedirect
    : defaultRedirect;

  return <Navigate to={href(destination, { pharmacyId })} replace />;
};
